<div class="profile-container">
  <div class="">
    <div class="profile-content">

      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">
            <select (change)="getAllObjectAllocationRegistersByObjectId()"
              style="text-align: center;margin-bottom: 0;margin-right: 10px;" name="" id="" [(ngModel)]="objectInfoId"
              class="form-control">
              <option value=""> -- Asset --</option>
              <option value="{{list.objectInfoId}}" style="text-transform: capitalize;"
                *ngFor="let list of objectInfoList">{{list.givenName}}</option>
            </select>
            <div class="search">
              <form autocomplete="off">
                <input type="text" (keyup.enter)="getAllObjectAllocationRegistersByWildSearch()"
                  [ngModelOptions]="{standalone: true}" placeholder="search" [(ngModel)]="searchFilter">
              </form>
              <i class="bi bi-search" (click)="getAllObjectAllocationRegistersByWildSearch()"></i>
            </div>
            <div class="filter-icon">
              <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
            </div>
          </div>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>

              <th style="width: 10%;">{{ 'object-allocation-register.objectAllocationRegisterId' | translate }}</th>
              <th style="width: 20%;">{{ 'object-allocation-register.givenName' | translate }}</th>
              <th style="width: 10%;">{{ 'object-allocation-register.objectSerialNo' | translate }}</th>
              <th style="width: 20%;">{{ 'object-allocation-register.issuedToUserName' | translate }} </th>
              <th style="width: 15%;">{{ 'object-allocation-register.issuedByUserName' | translate }} </th>
              <th style="width: 15%;">{{ 'object-allocation-register.issuedDate' | translate }}</th>
              <!-- <th style="width: 10%;">Status</th> -->
              <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
            </tr>
          </thead>
        </table>
        <div *ngIf="!isLoading">
          <div class="data-view" id="{{list.id}}"
            [ngClass]="{ 'delete-highlight': list.objectAllocationRegisterId == recordId }" *ngFor="let list of objectAllocationRegisterList | paginate : {
                          itemsPerPage: tableSize,
                          currentPage: page,
                          totalItems: count
                        }  ;let i = index">

            <p style="width: 10%;">{{list.objectAllocationRegisterId}}</p>
            <p style="width: 20%;">{{list.givenName}}</p>
            <p style="width: 10%;">{{list.objectSerialNo}}</p>
            <p style="width: 20%;">{{list.issuedToUserName || '--'}}</p>
            <p style="width: 15%;">{{list.issuedByUserName || '--'}}</p>
            <p style="width: 15%;"><span *ngIf="list.issuedDate != 0">{{list.issuedDate | date }}</span> </p>
            <!-- <p style="width: 10%;">{{list.latestStatus }}</p> -->


            <p class="action-buttons" style="width: 10%;padding-left: 25px;">
              <i data-toggle="modal" title="View"
                (click)="getObjectAllocationRegisterById(list.objectAllocationRegisterId)" data-target="#viewModal"
                class="bi bi-eye-fill"></i>
            </p>
          </div>
        </div>


        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>

        <div class="loader" *ngIf="!isLoading && objectAllocationRegisterList.length == 0">
          <div class="no-data">
            <img src="assets/no-data-6.png" alt="">
            <p>no data found</p>
          </div>

        </div>

        <div class="paginator">
          <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
            [totalRecords]="count" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} of {totalRecords}">
          </p-paginator>
        </div>


      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content" *ngFor="let viewData of singleObjectAllocationRegisterData">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-allocation-register.headings.detail' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.givenName' | translate }} :</label>
                <p>{{viewData.givenName || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.objectSerialNo' | translate }} :</label>
                <p>{{viewData.objectSerialNo || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.issuedToUserName' | translate }} :</label>
                <p>{{viewData.issuedToUserName || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.issuedByUserName' | translate }} :</label>
                <p>{{viewData.issuedByUserName || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.issuedDate' | translate }} :</label>
                <p>{{viewData.issuedDate | date}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Last Returned On :</label>
                <p>{{viewData.returnedOn | date}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.remarks' | translate }} :</label>
                <p>{{viewData.remarks || '--'}}</p>
              </div>

              <!-- <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.latestStatus' | translate }} :</label>
                <p>{{viewData.latestStatus || '--'}}</p>
              </div> -->

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.description' | translate }} :</label>
                <p>{{viewData.description || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.latestStatus' | translate }} :</label>
                <p style="text-transform: lowercase; text-transform: capitalize;">{{(viewData.latestStatus ||
                  '--').toLowerCase()}}</p>
              </div>

              <div class="col-md-12 col-lg-12">
                <div class="status-table">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 50%;">{{ 'object-allocation-register.userId' | translate }}</th>
                        <th style="width: 20%;text-align: center;">{{ 'object-allocation-register.issueStatus' |
                          translate }}</th>
                        <th style="width: 30%;text-align: center;">{{ 'object-allocation-register.updatedDate' |
                          translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let status of viewData.status">
                        <td style="width: 50%;">{{status.userId}}</td>
                        <td style="width: 20%;text-align: center;">{{status.issueStatus}}</td>
                        <td style="width: 30%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel'
            | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>